import { SIcon, SRow } from '@avalara/skylab-sdk/react';
import { useState } from 'react';
import { useSelector } from 'react-redux';

import { selectState } from '../../selectors';
import { BlueHeading, CheckItem, Slider } from '../shared/accordion-styled-components';
import CustomOfferDetails from './custom-offer-details';

const OfferDetails = () => {
  const {
    offer: { offerDetails, offerName, offerFlow },
  } = useSelector(selectState);

  const accordionOpenDefaults = offerDetails?.map(({ openAccordion }) => !!openAccordion);
  const [accordionOpenStatuses, setAccordionOpenStatuses] = useState(accordionOpenDefaults || []);
  const toggleAccordion = (i: number) => {
    accordionOpenStatuses[i] = !accordionOpenStatuses[i];
    // NOTE: Need to recreate array to trigger UI refresh
    setAccordionOpenStatuses([...accordionOpenStatuses]);
  };

  if (!offerDetails) return null;

  return (
    <>
      {offerDetails.map(({ accordionHeaderText, features, offerInfo, showOfferName }, i) => (
        <div key={`${accordionHeaderText}-${features?.join('-')}`} className={i === 0 ? 'pad-top-md' : ''}>
          <hr className='pad-bottom-sm' />
          <span className='flex align-items-center pad-bottom-sm'>
            <button type='button' className='ghost-blue icon' onClick={() => toggleAccordion(i)}>
              <SIcon
                className='medium'
                name={accordionOpenStatuses[i] ? 'chevron-up' : 'chevron-down'}
                aria-label={accordionOpenStatuses[i] ? 'Collapse offer details' : 'Expand offer details'}
                role='button'
              />
            </button>
            <div className='flex flex-dir-col'>
              <BlueHeading className='font-bold pad-left-sm'>{accordionHeaderText}</BlueHeading>
            </div>
          </span>
          <Slider show={accordionOpenStatuses[i]}>
            <div className='pad-left-lg'>
              {showOfferName && <h3>{offerName}</h3>}
              {features?.map((feature) => (
                <CheckItem key={`feature${feature}`}>
                  <SIcon name='check' />
                  <span>{feature}</span>
                </CheckItem>
              ))}
              <SRow>
                {offerInfo?.map((info) => (
                  <p key={`offerInfo${info}`} className='text-md font-normal margin-bottom-md margin-left-lg'>
                    {info}
                  </p>
                ))}
                <CustomOfferDetails offerFlow={offerFlow} />
              </SRow>
            </div>
          </Slider>
        </div>
      ))}
      <hr className='pad-top-lg' style={{ width: '100%' }} />
    </>
  );
};

export default OfferDetails;
